import {useCallback,useEffect,useState,type SetStateAction} from 'react';
export function readLocalDraft<T>(key:string,fallback:T):T{
  try{const raw=localStorage.getItem(key);if(!raw)return fallback;const value:unknown=JSON.parse(raw);
    if(Array.isArray(fallback))return Array.isArray(value)?value as T:fallback;
    if(fallback!==null&&typeof fallback==='object')return value!==null&&typeof value==='object'&&!Array.isArray(value)?value as T:fallback;
    return typeof value===typeof fallback&&(fallback===null||value!==null)?value as T:fallback;
  }catch{return fallback}
}
export function useLocalDraft<T>(key:string,fallback:T){
  const [record,setRecord]=useState(()=>({key,value:readLocalDraft(key,fallback)}));
  const current=record.key===key?record:{key,value:readLocalDraft(key,fallback)};
  if(record.key!==key)setRecord(current);
  const setValue=useCallback((next:SetStateAction<T>)=>setRecord(previous=>previous.key!==key?previous:{key,value:typeof next==='function'?(next as (value:T)=>T)(previous.value):next}),[key]);
  const [error,setError]=useState('');
  useEffect(()=>{
    if(record.key!==key)return;
    try{localStorage.setItem(key,JSON.stringify(record.value));setError('')}
    catch{setError('Черновик сейчас только на экране: в браузере недостаточно места. Не закрывайте страницу.')}
  },[key,record]);
  return[current.value,setValue,error] as const;
}
